<template>
	<v-container>
		<h4>Auditoria: Seleccione a una persona.</h4>
		<v-autocomplete
			:loading="loadingPersons"
			:items="persons"
			:item-text="text"
			:item-value="value"
			outlined
			filled
			dense
			solo
			v-model="idPerson"
			label="Seleccione una persona"
			no-data-text="No hay personas"
			hide-details
			@change="e => onChange(e)"
		></v-autocomplete>
		<div>
			<v-text-field
				dense
				solo
				outlined
				filled
				small
				label="Mes a visualizar"
				hide-details
				loader-height="4"
				color="info"
				type="month"
				v-model="mes"
			></v-text-field>
		</div>
	</v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
	props: {
		setLoading: {
			type: Function,
			required: true,
		},
	},
	data() {
		return {
			loadingPersons: false,
			idPerson: null,
		};
	},
	computed: {
		mes: {
			get: function() {
				return this.month;
			},
			set: function(newValue) {
				this.setMonth(newValue);
			},
		},
		...mapGetters({
			persons: 'Audit/personWithAudit',
			month: 'Lodging/month',
		}),
	},
	async mounted() {
		this.loadingPersons = true;
		await this.getPersonWithAudit();
		this.loadingPersons = false;
	},
	methods: {
		text(text) {
			if (text.delete)
				return `${text.delete.firstName} ${
					text.delete.lastName ? text.delete.lastName : ''
				}`;
			else if (text.person)
				return `${text.person.firstName} ${
					text.person.lastName ? text.person.lastName : ''
				}`;
			else {
				return 'No clickear, antiguo modelo';
			}
		},
		value(text) {
			if (text.delete) {
				return text.delete.person;
			} else if (text.person) {
				return text.person._id;
			} else {
				return '';
			}
		},
		async onChange(e) {
			this.setLoading(true);
			await this.getAudit({ idPerson: e });
			this.setLoading(false);
		},
		...mapMutations({ setMonth: 'Lodging/setMonth' }),
		...mapActions({
			getAudit: 'Audit/getOneAudits',
			getPersonWithAudit: 'Audit/getPersonWithAudit',
		}),
	},
};
</script>
